import React, { useEffect, useRef, useState } from "react"
import { CustomHeader } from "../../../components/headers/CustomHeader"
import { Button, Card, Checkbox, Tooltip } from "@material-tailwind/react"
import {
  CardBody,
  IconButton,
  Input,
  Spinner,
  Typography,
} from "@material-tailwind/react"
import moment from "moment"
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai"
import { toast } from "react-toastify"
import { BASEURL, DEFAULTPRIMARYCOLOR } from "../../../util"
import { GiCheckMark } from "react-icons/gi"
import { GrClose } from "react-icons/gr"
import { DetailDrawer } from "../../../components"
import CollectionDetail from "../../../components/Details/collection-detail copy"
import { UserType } from "../../../types/user"
import SendMessageDetails from "../../../components/Details/SendMessageDetails"
import { DriverModal } from "../../../components/modal/DriverModal"
import dataDemo from "../../../data"
import { FiDownloadCloud } from "react-icons/fi"
import Papa from "papaparse"
import { useHistory, Link, useLocation } from "react-router-dom"
import { DRIVERAGGREGATE, GET_ALL_DRIVERS } from "../../../GraphQl/queries"
import { useQuery, useLazyQuery } from "@apollo/client"
import DriverColectionDetails, {
  CollectionRequest,
} from "../../../components/Details/driver-collection-detail"
import GeneralPagination from "../../../components/paginations/generalpagination"
import { RiAdminLine } from "react-icons/ri"
import { DriverAggreateType } from "../../../types/query"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { getColorCode } from "../../../colorCodes"
import DriverArrears from "./DriverArrears"
import PerPageAndPagination from "../../../components/paginations/perpageAndPagination"
import dayjs from "dayjs";

export type ResponseType = {
  amount: number
  created_at: string
  created_by: string
  payment_mode: string
  driver_current_balance: number
  id: string
  reference_number: string
  status: string
  company_staff: {
    id: string
    name: string
    phone_number_one: string
  }
  sub_agent: {
    id: string
    first_name: string
    last_name: string
    phone_number: string
  }
  driver: {
    account_status: string
    address: string
    balance: number
    bank_details: null
    consent: false
    dob: null
    email: string
    gender: string
    id_card_type: string
    id: string
    id_number: string
    momo_wallet_details: {
      network: string
      number: string
    }
    phone_number_1: string
    phone_number_2: string
    full_name: string
  }
  agent_staff_details: {
    id: string
    phone_number: string
    first_name: string
    last_name: string
  }
}

export type DriversDataType = {
  account_status: string
  balance: number
  date_created: string
  driver_code: string
  driver_license_number: string
  nationality: string
  weekly_income_range: string
  driver_id: string
  driver_name: string
  phone_number: string
  total_number_of_policies: number
  total_premium_balance: number
  total_premium_paid: number
  total_premium_payable: number
  total_arrears: number
  wallet_number: string
  usertype: string
  created_by: string
}

const ManageDriver = () => {
  const history = useHistory()
  const [searchText, setSearchText] = useState("")
  const [selectedRow, setSelectedRow] = useState<DriversDataType | null>(null)
  const [openSideNav, setOpenSideNav] = useState<boolean>(false)
  const [openSendMessage, setOpenMessage] = useState<boolean>(false)
  const [selectedMessagesRows, setSelectedMessagesRows] = useState<string[]>([])
  const defaultStart = moment().subtract(1, "months").format("YYYY-MM-DDTHH:mm");
  const defaultEnd = moment().format("YYYY-MM-DDTHH:mm");
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [tempStartDate, setTempStartDate] = useState(defaultStart);
  const [tempEndDate, setTempEndDate] = useState(defaultEnd);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [selectedThick, setSelectedThick] = useState<DriversDataType[] | []>([])
  const [searchData, setSearchData] = useState<DriversDataType[] | undefined>(undefined);
  const [searchFilterStart, setSearchFilterStart] = useState("");
  const [searchFilterEnd, setSearchFilterEnd] = useState("");

  const { user: stateUser, token } = useSelector(
    (state: RootState) => state.auth
  )

  const handleStartDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
    setStartDate(formattedValue)
  }

  const handleEndDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
    setEndDate(formattedValue)
  }

  const handleSearch = () => {
    search()
  }

  const handleTempStartDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const dateOnly = value.split("T")[0]; // Extract just the date part
      const formattedValue = `${dateOnly}T00:00`; // Set time to 12:00 AM
      setTempStartDate(formattedValue);
    }
  }

  const handleTempEndDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const formattedValue = value
      setTempEndDate(formattedValue)
    }
  }

  const handleDateChange = () => {
    const start = dayjs(tempStartDate);
    const end = dayjs(tempEndDate);
    const diffInMonths = end.diff(start, 'month', true);

    setIsFilterLoading(true);
    if (searchData !== undefined) {
      setSearchFilterStart(tempStartDate)
      setSearchFilterEnd(tempEndDate)
      setIsFilterLoading(false);
    } else {
      if (diffInMonths > 3) {
        setTempStartDate(defaultStart);
        setTempEndDate(defaultEnd);
        toast.error("Date range cannot exceed 3 months.");
        setIsFilterLoading(false);
        return;
      }


      setTimeout(() => {
        fetchData({
          variables: {
            start_date: tempStartDate,
            end_date: tempEndDate
          }
        });
        setIsFilterLoading(false);
      }, 1000);
    }
  };

  const reset = () => {
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setTempStartDate(defaultStart);
    setTempEndDate(defaultEnd);
    setSearchFilterStart("");
    setSearchFilterEnd("");
    if (searchData === undefined) {
      fetchData({
        variables: {
          start_date: defaultStart,
          end_date: defaultEnd
        }
      });
    }
  }

  const { data: totalDrivers, loading: load } =
    useQuery<DriverAggreateType>(DRIVERAGGREGATE)

  const [fetchData, {
    loading: Loading,
    error,
    data: driverData,
  }] = useLazyQuery<{
    view_driver_policy_totals_details: DriversDataType[]
  }>(GET_ALL_DRIVERS)

  useEffect(() => {
    fetchData({
      variables: {
        start_date: defaultStart,
        end_date: defaultEnd
      }
    });
  }, []);


  //--------------------
  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked && paginatedData) {
      const allRows = paginatedData?.map((item) => item.driver_id)
      setSelectedMessagesRows(allRows)
      setSelectedThick(paginatedData)
    } else {
      setSelectedMessagesRows([])
      setSelectedThick([])
    }
  }

  const handleRowCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    item: DriversDataType
  ) => {
    if (event.target.checked) {
      setSelectedMessagesRows([...selectedMessagesRows, item?.driver_id])
      setSelectedThick([...selectedThick, item])
    } else {
      setSelectedMessagesRows(
        selectedMessagesRows?.filter((obj) => obj !== item?.driver_id)
      )
      setSelectedThick(
        selectedThick?.filter((obj) => obj.driver_id !== item?.driver_id)
      )
    }
  }

  const search = async () => {
    if (searchText) {
      try {
        setIsFilterLoading(true)
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/search-drivers-v2?search_term=${searchText}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )

        const req = await response.json()

        if (response.ok) {
          setSearchData(req.data)
          toast.success(req?.message)
        } else {
          // setSearchData("")
          toast.error(req?.message)
        }
        setIsFilterLoading(false)
      } catch (error) {
        // setSearchData("")
        toast.error("Could not perform search")
        setIsFilterLoading(false)
      }
    }
  }

  const filterData = (filter: DriversDataType) => {
    const date = moment(filter?.date_created).format("LLL")
    const isTextMatch =
      filter?.account_status
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      date?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.total_number_of_policies
        .toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.total_premium_payable
        .toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.total_premium_paid
        .toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.total_premium_balance
        .toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.balance
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.driver_code?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.driver_id?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.driver_name?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.phone_number
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.wallet_number?.toLowerCase()?.includes(searchText?.toLowerCase())
    return isTextMatch
  }

  function filterDate(item: DriversDataType): boolean {
    const date = new Date(item?.date_created);
    const start = new Date(searchFilterStart);
    const end = new Date(searchFilterEnd);

    return date >= start && date <= end;
  }


  const [currentPage, setCurrentPage] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  useEffect(() => {
    if (searchText || startDate || endDate || itemsPerPage) {
      setCurrentPage(0)
    }
  }, [searchText, startDate, endDate, itemsPerPage])

  const displayData = searchData !== undefined ? searchData : driverData?.view_driver_policy_totals_details

  const totalItems = (searchFilterStart || searchFilterEnd) ? displayData?.filter(filterDate) : displayData

  // ?.filter(filterData)
  // ?.filter((item: any) => {
  //   const normalizeDate = (date: Date | string): Date => {
  //     const normalizedDate = new Date(date)
  //     normalizedDate.setHours(0, 0, 0, 0) // Set time to midnight to include the entire day
  //     return normalizedDate
  //   }
  //   const from =
  //     (startDate as any) instanceof Date
  //       ? normalizeDate(startDate)
  //       : normalizeDate(startDate)
  //   const to =
  //     (endDate as any) instanceof Date
  //       ? normalizeDate(endDate)
  //       : normalizeDate(endDate)
  //   const dateCreated = normalizeDate(item.date_created)
  //   // Convert date_created to Date object
  //   // Check if dateCreated falls within the range (inclusive)
  //   if (startDate && endDate) {
  //     return dateCreated >= from && dateCreated <= to // Corrected to <= for endDate
  //   } else if (startDate) {
  //     return dateCreated >= from // Only from date is set
  //   } else if (endDate) {
  //     return dateCreated <= to // Only to date is set
  //   }
  //   return true // No filter applied
  // })

  // const paginatedData = totalItems?.slice(startIndex, endIndex)
  const endOffset = currentPage + itemsPerPage
  const paginatedData = totalItems?.slice(currentPage, endOffset)



  const userData = stateUser
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      // const data: UserType = JSON.parse(userData)

      const colors = getColorCode(stateUser?.colors)

      setColors(colors)
    }
  }, [stateUser?.colors, userData])

  const handleDownload = () => {
    // Check if there is data to download
    if (driverData?.view_driver_policy_totals_details?.length === 0) {
      alert("No data to download.")
      return
    }
    // Define custom headers based on the selected filter
    if (selectedThick.length > 0) {
      const change = selectedThick?.map((item) => ({
        "account status": item?.account_status,
        "date created": item.date_created,
        "wallet number": item.wallet_number,
        usertype: item.usertype,
        "created by": item.created_by,
        "driver code": item.driver_code,
        "driver name": item.driver_name,
        "driver license number": item.driver_license_number,
        "nationality": item.nationality,
        "weekly income range": item.weekly_income_range,
        "phone number": item.phone_number,
        "total number of policies": item.total_number_of_policies,
        "total premium balance": item.total_premium_balance,
        "total premium paid": item.total_premium_paid,
        "total premium payable": item.total_premium_payable,
        "total arrears": item.total_arrears,
        balance: item.balance,
      }))
      const firstItem = change![0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = change?.map((item) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })
      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"driverdetails"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      return
    }
    if (searchText || startDate || endDate) {
      const change = totalItems?.map((item) => ({
        "account status": item?.account_status,
        balance: item.balance,
        "date created": item.date_created,
        "driver code": item.driver_code,
        "driver name": item.driver_name,
        "driver license number": item.driver_license_number,
        "nationality": item.nationality,
        "weekly income range": item.weekly_income_range,
        "phone number": item.phone_number,
        "total number of policies": item.total_number_of_policies,
        "total premium balance": item.total_premium_balance,
        "total premium paid": item.total_premium_paid,
        "total premium payable": item.total_premium_payable,
        "total arrears": item.total_arrears,
        "wallet number": item.wallet_number,
        usertype: item.usertype,
        "created by": item.created_by,
      }))
      const firstItem = change![0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = change?.map((item) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })
      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"driverdetails"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } else {
      const change = driverData?.view_driver_policy_totals_details?.map(
        (item) => ({
          "account status": item?.account_status,
          "date created": item.date_created,
          "wallet number": item.wallet_number,
          usertype: item.usertype,
          "created by": item.created_by,
          "driver code": item.driver_code,
          "driver name": item.driver_name,
          "driver license number": item.driver_license_number,
          "nationality": item.nationality,
          "weekly income range": item.weekly_income_range,
          "phone number": item.phone_number,
          "total number of policies": item.total_number_of_policies,
          "total premium balance": item.total_premium_balance,
          "total premium paid": item.total_premium_paid,
          "total premium payable": item.total_premium_payable,
          "total arrears": item.total_arrears,
          balance: item.balance,
        })
      )
      const firstItem = change![0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = change?.map((item) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })
      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"driverdetails"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }
  }

  // useEffect(() => {
  //   paginatedData?.map((item) => {})
  // }, [])
  return (
    <>
      <CustomHeader title="Manage Drivers" />
      {openSideNav ? (
        <DetailDrawer
          title="Driver's Information"
          open={openSideNav}
          size={500}
          onClose={() => setOpenSideNav(false)}
          children={<DriverColectionDetails content={selectedRow} />}
        />
      ) : openSendMessage ? (
        <DriverModal
          title=""
          open={openSendMessage}
          size={"md"}
          focus="message"
          onClose={() => setOpenMessage(false)}
          children={
            <SendMessageDetails
              driver={selectedMessagesRows}
              onClose={() => setOpenMessage(false)}
            />
          }
        />
      ) : null}

      <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-2 md:lg:gap-4 lg:gap-5">
        <Card className="bg-brand-info rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
          <div className="flex flex-row justify-between">
            <div>
              <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                {load ? (
                  <Spinner className="mb-2 text-white" />
                ) : (
                  // totalDrivers?.total_drivers?.aggregate?.count
                  totalItems?.length
                )}
              </Typography>
              <Typography className="text-sm uppercase font-normal text-white">
                total drivers
              </Typography>
            </div>
            <RiAdminLine size={28} color="#cbcbcb" />
          </div>
        </Card>
      </div>

      <div className="mt-10 w-full ">
        <CardBody className="shadow-sm overflow-x-scroll w-full px-0 py-0  rounded-3xl">
          <div className="bg-black pt-5">
            <Typography
              variant="h6"
              style={{
                color:
                  colors?.length! > 1
                    ? `${colors![0]?.toLowerCase()}`
                    : `${DEFAULTPRIMARYCOLOR}`,
              }}
              className="px-4 pb-4  font-bold leading-none opacity-70"
            >
              List of Drivers{" "}
              <span className="text-white">
                {
                  // totalDrivers?.total_drivers?.aggregate?.count
                  totalItems?.length
                }
              </span>
            </Typography>
          </div>
          <div className="w-full overflow-auto">
            <div className="">
              <div className="flex flex-col  gap-y-4  bg-white px-3 py-4">
                <div className="flex shrink-0 flex-col justify-end gap-2 sm:flex-row">
                  <Tooltip content="Export as CSV">
                    <Button
                      onClick={handleDownload}
                      variant="filled"
                      className="capitalize text-sm font-normal flex flex-wrap gap-2"
                      size="sm"
                    >
                      <FiDownloadCloud size={20} />
                      <span>Download csv</span>
                    </Button>
                  </Tooltip>
                </div>
                <div className=" p-3 flex gap-x-2 items-center flex-col 2xl:flex-row gap-y-3 mb-3">
                  <div className=" mr-3 flex  gap-x-3 w-full">
                    <Input
                      crossOrigin="anonymous"
                      label="Search"
                      placeholder=""
                      value={searchText}
                      onChange={(e) => {
                        setSearchText(e.target.value)
                        if (e.target.value === "") {
                          setSearchText("")
                          setSearchData(undefined)
                          setSearchFilterStart("")
                          setSearchFilterEnd("")
                        }
                      }}
                      icon={<i className="fas fa-search text-base"></i>}
                    />
                    <Button
                      onClick={handleSearch}
                      variant="filled"
                      className="capitalize text-sm font-normal flex flex-wrap gap-2 justify-center items-center"
                      size="sm"
                    >
                      <span>Search</span>
                    </Button>
                  </div>
                  <div className="flex flex-col xl:flex-row gap-3 justify-between mb-0">
                    <div className="flex items-center space-x-2">
                      <label className="font-semibold text-gray-700">
                        From
                      </label>
                      <Input
                        type="datetime-local"
                        value={tempStartDate} // Remove 'Z' for input value
                        onChange={handleTempStartDateChange}
                        size="md"
                        className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                        labelProps={{
                          className: "before:content-none after:content-none",
                        }}
                      />
                    </div>
                    <div className="flex items-center space-x-2">
                      <label className="font-semibold text-gray-700">To</label>
                      <Input
                        type="datetime-local"
                        value={tempEndDate} // Remove 'Z' for input value
                        onChange={handleTempEndDateChange}
                        size="md"
                        className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                        labelProps={{
                          className: "before:content-none after:content-none",
                        }}
                      />
                    </div>
                    <div className="flex items-center space-x-2">
                      <Tooltip content="Apply date filters">
                        <Button
                          onClick={handleDateChange}
                          variant="filled"
                          className="capitalize text-sm font-normal flex flex-wrap gap-2"
                          size="sm"
                        >
                          <span>Filter</span>
                        </Button>
                      </Tooltip>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Tooltip content="Clear All Date filters">
                        <Button
                          onClick={reset}
                          variant="filled"
                          className="capitalize text-sm font-normal flex flex-wrap gap-2"
                          size="sm"
                        >
                          <span>Clear</span>
                        </Button>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {selectedMessagesRows.length >= 2 && (
            <div className=" bg-white w-full pl-3 flex pb-2">
              <h1
                className=" bg-blue-600 px-2 py-2 rounded w-auto text-white cursor-pointer "
                onClick={() => setOpenMessage(true)}
              >
                Send Messages ({selectedMessagesRows.length})
              </h1>
            </div>
          )}
          <CardBody className="px-0 py-0">
            <div
              className="overflow-x-auto overflow-y-auto"
              style={{ maxHeight: "65vh" }}
            >
              <table className="w-full bg-white min-w-max table-auto">
                <thead className="bg-white sticky z-50 top-0">
                  <tr className="">
                    {[
                      "Driver Code",
                      "Driver Name",
                      "Driver License Number",
                      "Nationality",
                      "Weekly Income Range",
                      "Phone Number",
                      "Wallet Number",
                      "Wallet Balance",
                      "Number of Policies",
                      "Policy Premium Payable",
                      "Policy Premium Paid",
                      "Policy Premium Balance",
                      "Arrears",
                      "Account Status",
                      "staff/agent",
                      "Date Registered",
                      "Actions",
                    ].map((head) => (
                      <th
                        key={head}
                        className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-2 py-4  "
                      >
                        <Typography
                          color="black"
                          className="font-bold text-[0.8rem] text-black leading-none opacity-70 capitalize"
                        >
                          {head === "Driver Code" ? (
                            <div className=" flex items-center">
                              {" "}
                              <Checkbox
                                color="blue"
                                // checked={true}
                                onChange={handleSelectAll}
                                checked={
                                  selectedMessagesRows.length ===
                                  paginatedData?.length
                                }
                                size={3}
                                className=" text-xs mr-1"
                                value={undefined}
                              />
                              {head}
                            </div>
                          ) : (
                            head
                          )}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {paginatedData?.map((item, index: number) => {
                    const isLast = index === paginatedData?.length - 1
                    const classes = isLast
                      ? "px-2 py-3  text-center"
                      : "px-2 py-3 border-b-2 border-blue-gray-50 text-center"

                    return (
                      <>
                        <tr
                          onClick={(e) => {
                            setSelectedRow(item!)
                            e.stopPropagation()
                            setOpenSideNav(true)
                          }}
                          key={item?.driver_id}
                          className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                        >
                          <>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal text-[0.75rem] capitalize  "
                              >
                                <div className=" flex items-center mr-10">
                                  <Checkbox
                                    color="blue"
                                    onChange={(event) => {
                                      handleRowCheckboxChange(event, item)
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                    }}
                                    checked={
                                      selectedMessagesRows.length > 0 &&
                                      selectedMessagesRows.includes(
                                        item.driver_id
                                      )
                                    }
                                    // checked={true}
                                    // onClick={(e) => {
                                    //   e.stopPropagation()
                                    // }}
                                    size={3}
                                    className=" text-xs mr-1"
                                    value={undefined}
                                  />
                                  {item?.driver_code}
                                </div>
                              </Typography>
                            </td>
                          </>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.driver_name}
                            </Typography>
                          </td>
                           <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.driver_license_number ?? "N/A"}
                            </Typography>
                          </td>
                           <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.nationality ?? "N/A" }
                            </Typography>
                          </td>
                           <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.weekly_income_range ?? "N/A"}
                            </Typography>
                          </td>

                          {/* <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize"
                        >
                          GHS
                          {(item?.amount ?? 0).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </Typography>
                      </td> */}
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.phone_number}
                            </Typography>
                          </td>
                          {/* <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize"
                        >
                          GHS
                          {(item?.driver_current_balance ?? 0).toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </Typography>
                      </td> */}
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.wallet_number}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              GHS {""}
                              {(item?.balance ?? 0).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.total_number_of_policies}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              GHS {""}
                              {(
                                item?.total_premium_payable ?? 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              GHS {""}
                              {(item?.total_premium_paid ?? 0).toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              GHS{" "}
                              {(
                                item?.total_premium_balance ?? 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              GHS{" "}
                              {(item?.total_arrears ?? 0).toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.account_status}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize text-left pl-7"
                            >
                              Name:{" "}
                              <span className="font-normal">
                                {item?.created_by}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize text-left pl-7"
                            >
                              Client Type:{" "}
                              <span className="font-normal">
                                {item?.usertype}
                              </span>
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {moment(item?.date_created).format("LLL")}
                            </Typography>
                          </td>

                          {/* <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize"
                        >
                          {new Date(item?.created_at).toLocaleDateString()}
                        </Typography>
                      </td>
                      */}

                          <td
                            className={classes}
                            onClick={(e) => {
                              e.stopPropagation()
                            }}
                          >
                            <div className="flex gap-2 mr-2">
                              {/* <Link to="/dashboard/i2i/edit-driver-detail"> */}
                              <Button
                                onClick={() => {
                                  localStorage.setItem(
                                    "driver",
                                    JSON.stringify({
                                      driver_id: item?.driver_id,
                                      driver_status: item?.account_status,
                                      driver_name: item?.driver_name,
                                      driver_phone: item?.phone_number,
                                      deposit_balance: item?.balance,
                                      date_created: item?.date_created,
                                    })
                                  );
                                  history.push("/dashboard/i2i/edit-driver-detail")

                                }}
                                className="capitalize bg-blue-900 text-sm font-normal flex flex-wrap gap-2"
                                size="sm"
                              >
                                <span>Edit</span>
                              </Button>
                              {/* </Link> */}
                              <Button
                                // onClick={() => handleRowClick(item)}
                                onClick={() => {
                                  localStorage.setItem(
                                    "driver",
                                    JSON.stringify({
                                      driver_id: item?.driver_id,
                                      driver_status: item?.account_status,
                                      driver_name: item?.driver_name,
                                      driver_phone: item?.phone_number,
                                      deposit_balance: item?.balance,
                                      date_created: item?.date_created,
                                    })
                                  )
                                  history.push("/dashboard/i2i/manage-driver")
                                  //()
                                }}
                                variant="filled"
                                color="green"
                                className="font-normal text-xs w-20 py-1 capitalize"
                              >
                                View More
                              </Button>
                            </div>
                          </td>
                        </tr>
                      </>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </CardBody>
          {(Loading || isFilterLoading) && (
            <div className="mt-10 flex items-center justify-center">
              <Spinner className="w-10 h-10" />
            </div>
          )}

          {paginatedData?.length! === 0 && !Loading && !isFilterLoading && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="white" variant="h6">
                No data found
              </Typography>
            </div>
          )}
        </CardBody>

        {/* {paginatedData && paginatedData?.length !== 0 && !Loading && (
          <GeneralPagination
            totalItems={totalItems?.length!}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />

        )} */}

        {paginatedData && paginatedData?.length !== 0 && !Loading && !isFilterLoading && (
          <PerPageAndPagination
            customColor="white"
            total={totalItems?.length!}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            perPage={itemsPerPage}
            setPerPage={setItemsPerPage}
          />
        )}
      </div>
    </>
  )
}

export default ManageDriver
